import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

interface PurchaseNowPlatformsParams {
  company_id?: string;
}

export interface PurchaseNowPlatforms {
  resultKey?: string;
  successCallback?: Function;
  errorCallback?: Function;
  params?: PurchaseNowPlatformsParams;
}

export default ({ resultKey = 'purchaseNowPlatforms', successCallback, errorCallback, params }: PurchaseNowPlatforms) =>
  requestAsync({
    url: endpoints.getPurchaseNowPlatformsUrl(params),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getPurchaseNowPlatformsUrl(params),
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
